export function Spinner({ small = false }: { small?: boolean }) {
  return (
    <span
      className={`nvd-claim-portal__spinner${small ? ' nvd-claim-portal__spinner--small' : ''}`}
      role="status"
      aria-label="Loading"
    />
  );
}
